import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const LockIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0069 15.005C13.0424 15.005 13.8819 14.1655 13.8819 13.1299C13.8819 12.0944 13.0424 11.2549 12.0069 11.2549C10.9713 11.2549 10.1318 12.0944 10.1318 13.1299C10.1318 14.1655 10.9713 15.005 12.0069 15.005Z"
        stroke={color}
        strokeWidth="1.50003"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0098 15.0044V17.2544"
        stroke={color}
        strokeWidth="1.50003"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5072 8.25488H4.50685C4.09263 8.25488 3.75684 8.59068 3.75684 9.0049V19.5051C3.75684 19.9193 4.09263 20.2551 4.50685 20.2551H19.5072C19.9214 20.2551 20.2572 19.9193 20.2572 19.5051V9.0049C20.2572 8.59068 19.9214 8.25488 19.5072 8.25488Z"
        stroke={color}
        strokeWidth="1.50003"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.63281 8.25404V4.87897C8.63281 3.98385 8.9884 3.12539 9.62135 2.49244C10.2543 1.85949 11.1128 1.50391 12.0079 1.50391C12.903 1.50391 13.7615 1.85949 14.3944 2.49244C15.0274 3.12539 15.3829 3.98385 15.3829 4.87897V8.25404"
        stroke={color}
        strokeWidth="1.50003"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default memo(LockIcon);
